import React, { useEffect, useState } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { BackButton, Button, Collapsible, Fab, Input, Modal, Title } from '../../../../components/UI/ComponentsUI';
import SecurityService from '../../../../services/SecurityService';
import StockService from '../../../../services/StockService';
import { ENUMS } from '../../../../utils/constants';
import { onValueChange, validateInputsRequired } from "../../../../utils/handleChangeHooks";
import { closeCollapsible, convertToUppercase, isNullOrEmpty, showMessageToastCustom, translate } from '../../../../utils/util';
import DropMaterialBarCode from '../DropMaterial/DropMaterialBarCode';
import MaterialItems from './MaterialItems';
import ModalBottomSheetUI from '../../../../components/UI/ModalBottomSheetUI';
import MaterialItemsPab from './MaterialItemsPab';


const SearchMaterial = (props) => {
    const quality = props.history?.location?.state?.quality;
    const isPreAllocation = props.history?.location?.state?.isPreAllocation;
    const isPabReplanning = props.history?.location?.state?.pabReplanning;
    const [openItensModal, setOpenItensModal] = useState(false);
    const [dataAdd, setDataAdd] = useState([]);
    const [filter, setFilter] = useState({
        partNumber: '',
        area: '',
        cim: '',
        print: 'C',
        resource: '',
        quantity: '',
        justification: '',
        masterCim: 'N',
        printer: undefined
    })
    const [filterSearch, setFilterSearch] = useState({
        area: props.filter?.area || '',
        isPreAllocation: isPreAllocation,
    })
    const [info, setInfo] = useState({ data: {}, open: true });

    useEffect(() => {
        if (!isNullOrEmpty(filterSearch.area)) {
            search();
        }
        // eslint-disable-next-line
    }, []);

    const onChange = (event) => {
        convertToUppercase(event)
        onValueChange(event, filterSearch, setFilterSearch);
    };


    const search = () => {
        setDataAdd([]);
        if (validateInputsRequired('formInput')) {
            props.getFilter(
                filterSearch,
                (response) => {
                    closeCollapsible('collapsibleStock')
                    if (isPreAllocation && response && response.length === 1) {
                        const data = response[0];
                        props.setFilter({});
                        props.setMaterials([]);
                        return props.history.push({
                            state: {
                                dataParams: data
                            },
                            pathname: './search/allocation'
                        });
                    }
                }
            );
        }
    }

    const onChangeModal = (event) => {
        onValueChange(event, filter, setFilter);
    };

    const confirm = () => {
        var dataAddObj = [];
        Object.assign(dataAddObj, dataAdd);
        dataAddObj.map((i) => i.operation = quality ? ENUMS.eStockOperation.Quality.value : ENUMS.eStockOperation.BarCode.value);
        props.confirmList(
            dataAddObj,
            () => {
                search();
            }
        );
    }

    const setResource = () => {
        if (filter.print === ENUMS.ePrintTypes.Click.value && !isNullOrEmpty(props.user?.resourceObj?.clickResourceName)) {
            return props.user?.resourceObj?.clickResourceName;
        }

        return props.user?.resourceObj?.name;
    }

    const validateResource = () => {
        if (!props.user?.resourceObj && filter.print !== ENUMS.ePrintTypes.NotPrint.value) {
            showMessageToastCustom(translate('warning', 'general'), translate('select-resource', 'validations'), 3000, 'mdi mdi-alert-circle-outline red-text');
            return false;
        }

        return true;
    }

    const onConfirmModal = () => {
        if (validateInputsRequired('ModalReceiptQuantity') && validateResource()) {
            filter.resource = setResource();
            filter.printer = props.user.printer;
            setDataAdd(oldArray => [...oldArray, filter]);
            openModal(false, {});
        }
    }

    const openModal = (openModal, data) => {
        setFilter({
            ...{
                partNumber: data.partNumberCode || "",
                area: data.area || "",
                cim: data.cim || "",
                print: 'C',
                resource: props.user.resource || '',
                quantity: data.qtd,
                justification: '',
                masterCim: 'N'
            }
        });
        setOpenItensModal(openModal);
    }


    const closeModal = () => {
        info.open = false;
        setInfo({ ...info });
    }

    return (
        <div>
            <BackButton {...props} />
            <Title label={translate('stock:write-off-by-location')} />
            <div className="container" >
                <Collapsible
                    id="collapsibleStock"
                    header={translate('stock:filter')}
                    body={
                        <div id="formInput" className="row no-margin-bottom">
                            <div className="row">
                                {!isPreAllocation &&
                                    <div className="input-field no-padding col s12">
                                        <Input
                                            required
                                            id="area"
                                            name='area'
                                            label={`${translate('stock:area')} / ${translate('stock:location')}`}
                                            type="text"
                                            value={filterSearch.area}
                                            onChange={onChange}
                                        />
                                    </div>
                                }
                            </div>
                            {!isPreAllocation &&
                                <div className="row">
                                    <div className="col s12 left">
                                        <Button
                                            full="true"
                                            className="col s6 btn-principal"
                                            text={translate('stock:search')}
                                            onClick={search}
                                        />
                                    </div>
                                </div>
                            }
                        </div>
                    }
                />
                {dataAdd && dataAdd.length > 0 &&
                    <Fab
                        buttons={[
                            { label: translate('change-location:top'), icon: <i className="mdi mdi-publish" />, color: 'darkgreen', onClick: () => { window.scrollTo(0, 0) } },
                            { label: "Enviar Selecionados", icon: <i className="mdi mdi-pencil-box-multiple" />, onClick: () => confirm() },

                        ]}
                    />
                }
                <ModalBottomSheetUI
                    open={info.open}
                    maxHeight="80%"
                    onClose={closeModal}
                    data={
                        <div className="row" style={{ marginBottom: '0' }}>
                            <div className="row" style={{ marginBottom: '0' }}>
                                <div className="no-padding col s4">
                                    <span className="active sixth-text-color" style={{ fontWeight: 'bold' }}>{translate('physical-confirmation:cim')}</span>
                                    <span className="field f-1r truncate sixth-text-color">{info.data?.cim}</span>
                                </div>
                                <div className="no-padding col s5">
                                    <span className="active sixth-text-color" style={{ fontWeight: 'bold' }}>{translate('physical-confirmation:part-number')}</span>
                                    <span className="field f-1r truncate sixth-text-color">{info.data?.partNumberCode}</span>
                                </div>
                                <div className="no-padding col s2">
                                    <span className="active sixth-text-color" style={{ fontWeight: 'bold' }}>{translate('physical-confirmation:quantity')}</span>
                                    <span className="field f-1r truncate sixth-text-color">{info.data?.qtd}</span>
                                </div>
                            </div>
                            <div className="row" style={{ marginBottom: '0' }}>
                                <div className="input-field no-padding col s12">
                                    <span className="active sixth-text-color" style={{ fontWeight: 'bold' }}>{translate('stock:description')}</span>
                                    <span className="field f-1r truncate sixth-text-color">{info.data?.partNumberDescription}</span>
                                </div>
                            </div>
                            <div className="row" style={{ marginBottom: '0' }}>
                                <div className="input-field no-padding col s6 m3">
                                    <span className="active sixth-text-color" style={{ fontWeight: 'bold' }}>{translate('change-location:location')}</span>
                                    <span className="field f-1r truncate sixth-text-color">{info.data?.location}</span>
                                </div>
                                <div className="input-field no-padding col s5 m3">
                                    <span className="active sixth-text-color" style={{ fontWeight: 'bold' }}>{translate('stock:location-target')}</span>
                                    <span className="field f-1r truncate sixth-text-color">{info.data?.locationTarget || '-'}</span>
                                </div>
                            </div>
                            <div className="row" style={{ marginBottom: '0' }}>
                                <div className="input-field no-padding col s6 m3">
                                    <span className="active sixth-text-color" style={{ fontWeight: 'bold' }}> {translate('stock:physical-status')}</span>
                                    <span className="field f-1r truncate sixth-text-color">{info.data?.physicalStatus}</span>
                                </div>
                                <div className="input-field no-padding col s5 m3">
                                    <span className="active sixth-text-color" style={{ fontWeight: 'bold' }}>{translate('stock:logical-status')}</span>
                                    <span className="field f-1r truncate sixth-text-color">{info.data?.logicalStatus || '-'}</span>
                                </div>
                            </div>
                            <div className="row" style={{ marginBottom: '0' }}>
                                <div className="input-field no-padding col s3">
                                    <span className="active sixth-text-color" style={{ fontWeight: 'bold' }}>{translate('physical-confirmation:journey')}</span>
                                    <span className="field f-1r truncate sixth-text-color">{info.data?.journey || '-'}</span>
                                </div>
                                <div className="input-field no-padding col s4">
                                    <span className="active sixth-text-color" style={{ fontWeight: 'bold' }}>{translate('physical-confirmation:invoice')}</span>
                                    <span className="field f-1r truncate sixth-text-color">{info.data?.invoice || '-'}</span>
                                </div>
                                <div className="input-field no-padding col s3">
                                    <span className="active sixth-text-color" style={{ fontWeight: 'bold' }}>{translate('physical-confirmation:supplier')}</span>
                                    <span className="field f-1r truncate sixth-text-color">{info.data?.supplier || '-'}</span>
                                </div>
                            </div>
                            <div className="row" style={{ marginBottom: '0' }}>
                                <div className="input-field no-padding col s12">
                                    <span className="active sixth-text-color" style={{ fontWeight: 'bold' }}>{translate('stock:notes')}</span>
                                    <span className="field f-1r truncate sixth-text-color">{info.data?.observation || '-'}</span>
                                </div>
                            </div>
                        </div>
                    }
                />
            </div>
            {
                props.materials.length > 0 && (<div className="container-fluid" style={{ marginTop: '5px', paddingBlockEnd: '50px' }}>
                    <ul className="collection col s12" style={{ paddingLeft: 0, paddingRight: 0 }}>
                        {
                            props.materials.map((item, index) => {
                                return (
                                    <li
                                        key={`oi-${index += 1}`}
                                        style={{ backgroundColor: 'white', boxShadow: '0 1px 5px 0 rgba(0,0,0,0.2)', padding: '4px', paddingBlockEnd: '12px' }}
                                    >
                                        {
                                            !isPabReplanning ?
                                                <MaterialItems

                                                    isPreAllocation={isPreAllocation}
                                                    quality={quality}
                                                    dataAdd={dataAdd}
                                                    setDataAdd={setDataAdd}
                                                    openModal={openModal}
                                                    {...props}
                                                    key={`key_${index}`}
                                                    item={item}
                                                    onClick={(i) => {
                                                        info.open = info.open ? false : true;
                                                        setInfo({ ...info, data: i })
                                                    }
                                                    }
                                                />
                                                :
                                                <MaterialItemsPab
                                                    isPreAllocation={isPreAllocation}
                                                    quality={quality}
                                                    showCimQtd={false}
                                                    openModal={openModal}
                                                    {...props}
                                                    key={`key_${index}`}
                                                    item={item}
                                                />
                                        }
                                    </li>
                                )
                            })}
                    </ul>
                </div>)
            }
            <Modal
                maxHeight="80%"
                open={openItensModal}
                id="ModalReceiptQuantity"
                children={
                    openItensModal ?
                        <DropMaterialBarCode
                            disable={true}
                            onChange={onChangeModal}
                            filter={filter} /> :
                        <></>
                }
                dismissible={false}
                onConfirm={() => onConfirmModal()}
                onCancel={() => openModal(false, {})}
                btnCancel={translate('stock:cancel')}
                btnConfirm={translate('stock:add')}
            />
        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        user: state.userReducer.user,
        materials: state.stockReducer.materials,
        filter: state.stockReducer.filter,
        resources: state.logisticsResourceReducer.list
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getFilter: (filter, callback) => {
            dispatch(StockService.search(filter, callback));
        },
        confirmOperation: (model, callback) => {
            dispatch(StockService.confirm(model, callback));
        },
        confirmList: (model, callback) => {
            dispatch(StockService.confirmList(model, callback));
        },
        setResource: (resource) => {
            dispatch(SecurityService.setResource(resource));
        },
        setPrinter: (printer) => {
            dispatch(SecurityService.setPrinter(printer));
        },
        setMaterials: (model) => {
            dispatch(StockService.setMaterials(model));
        },
        setFilter: (filter) => {
            dispatch(StockService.setFilter(filter));
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(SearchMaterial));